<template>
	<div>
		<v-row>
			<v-col>
				<Datatable title="Benutzerverwaltung" :headers="headers"
									 :items="users" :itemsPerPage="-1" item-slot="item:Group"
									 @click:row="openDialog"
									 @click:edit="openDialog"
									 @click:delete="openDeleteUserDialog"
				>
					<template #top>
						<Button icon="mdi-plus" :color="ada.blue" @click="openDialog(null)">Benutzer hinzufügen
						</Button>
					</template>
				</Datatable>
			</v-col>
		</v-row>
		<AddEditUserDialog v-model="showDialog" @click:delete="openDeleteUserDialog"></AddEditUserDialog>
		<DeleteUserDialog v-model="showDeleteDialog"></DeleteUserDialog>
	</div>
</template>

<script>
import Datatable from "../../components/Tables/Datatable";
import Utils from "../../scripts/Utils";
import ada from "../../scss/ada_colors.scss";
import Button from "../../components/buttons/Button";
import AddEditUserDialog from "./AddEditUserDialog";
import DeleteUserDialog from "./DeleteUserDialog";

export default {
	name: "Users",
	components: {DeleteUserDialog, AddEditUserDialog, Button, Datatable},
	data: () => {
		return {
			headers: [
				{text: 'Name', value: 'name'},
				{text: 'Mail', value: 'Mail'},
				{text: 'Rolle', value: 'role'},
				{text: 'Erstellt am', value: 'created_at'},
				{text: 'Aktion', value: 'action', width: '100px', sortable: false},
			],
			showDialog: false,
			selectedUser: null, //tried to put it in users store but then it wasn't reactive in watchers ._.
			showDeleteDialog: false,
			ada
		}
	},
	mounted() {
		this.fetchUsers();
	},
	computed: {
		vuexState() {
			return this.$store.state.users;
		},
		users() {
			let users = this.vuexState.users;
			users.forEach((user) => {
				user.name = Utils.getName(user.Mail);
				user.role = this.$store.state.users.roles.find(x => x.value === user.Group).text;
				user.created_at = Utils.formatDate(user.Created);
				user.action = ['edit', 'delete'];
			})
			return users;
		},
		role() {
			return this.$store.state.users.role;
		}
	},
	methods: {
		async fetchUsers() {
			if (this.users.length === 0) {
				await this.$store.dispatch('users/fetchUsers');
			}
		},
		async fetchUserDetails() {
			this.loading = true;
			await this.$store.dispatch('users/fetchUserDetails');
			this.loading = false;
		},
		openDialog(item) {
			this.selectedUser = item;
			this.showDialog = true;
		},
		openDeleteUserDialog(item) {
			this.selectedUser = item;
			this.showDeleteDialog = true;
		},
		async updateSelectedUser() {
			this.$store.commit('users/setSelectedUser', this.selectedUser);
			if (this.selectedUser) {
				await this.fetchUserDetails();
			} else {
				this.$store.commit('users/setUserDetails', null)
			}
		}
	},
	watch: {
		selectedUser() {
			this.updateSelectedUser();
		},
		showDialog(opened) {
			if (!opened) {
				this.selectedUser = null;
				this.$store.commit('users/setUserDetails', null);
			}
		},
		showDeleteDialog(opened) {
			if (!opened) {
				this.selectedUser = null;
				this.$store.commit('users/setUserDetails', null);
			}
		}
	}
}
</script>

<style scoped>

</style>